
// import headerList from "@/components/common/header-list.vue";
import { paginationMixin } from "@/mixins/paginationMixin";
import { _ } from "vue-underscore";
export default {
	data: () => ({
		selectedEvaluator:{},
		evaluator:{},
		comments:"",
		sortKey:"",
		evaluators: [],
		statesList:[],
		evaluations:[],
		tableData:[],
		noteList:[],
		error: "",
		searchText: "",
		selectFlaggedUnFlagged:"Not-Flagged",
		submitButtonValue:"Flagged",
		showLoader: false,
		allowToAddNewComment:false,
		sortBy:"",
		sortDirection:'asc'

	}),
	mixins: [paginationMixin],
	// components: { "header-list": headerList },
	computed: {
		selectedStudent() {
			return this.evaluations.filter(element => element.isSelected==true);
		}
	},
	methods: {
		applySort(sortBy){
			this.tableData = _.sortBy(this.tableData, function(column) { return column[sortBy]; });
			if(this.sortBy == sortBy && this.sortDirection=='asc'){
				this.sortDirection='desc';
				this.tableData = this.tableData.reverse();
			}else{
				this.sortDirection='asc';
			}
			this.sortBy = sortBy;
		},

		searchData(){
			const _vm =this;
			this.tableData = _.filter(this.evaluations,function(element){
				return (element.student_name && element.student_name.toLowerCase().indexOf(_vm.searchText.toLowerCase())>-1) ||
				(element.evaluator_name && element.evaluator_name.toLowerCase().indexOf(_vm.searchText.toLowerCase())>-1) ||
				(element.district_name && element.district_name.toLowerCase().indexOf(_vm.searchText.toLowerCase())>-1) ||
				(element.school_name && element.school_name.toLowerCase().indexOf(_vm.searchText.toLowerCase())>-1) ||
				(element.student_dob && element.student_dob.toLowerCase().indexOf(_vm.searchText.toLowerCase())>-1) ||
				(element.compliance_date && element.compliance_date.toLowerCase().indexOf(_vm.searchText.toLowerCase())>-1) ||
				(element.zip_code && element.zip_code.toLowerCase().indexOf(_vm.searchText.toLowerCase())>-1);
			})
		},
		addNewNotes(){

			this.allowToAddNewComment=true;
		},
		resetForm() {
			this.$refs.observer.reset();
			this.evaluator = {
				id: 0,
			};
		},
		changeSelectedEvalution(evaluation){
			this.comments = evaluation.comments;
		},
		saveNote() {
			let _vm = this;
			let fd = new FormData();
			fd.append("evaluation_note",this.comments);
			fd.append("evaluation_id",this.selectedEvaluator.id);
			this.axios
				.post("/set_add_evaluation_note.php", fd)
				.then(function() {
					_vm.comments="";
					_vm.allowToAddNewComment= false;
					_vm.loadNotes(_vm.selectedEvaluator.id);
				})
				.catch(function(error) {
					console.log(error);
				});
		},
		submit() {
			let _vm = this;
			let fd = new FormData();
			fd.append("update_type",_vm.selectFlaggedUnFlagged);
			fd.append("evaluation_id",this.selectedEvaluator.id);
			this.axios
				.post("/set_evaluations_as_un_flagged.php", fd)
				.then(function() {
					_vm.comments="";
					_vm.selectedEvaluator={};
					_vm.getOpenEvaluations();
				})
				.catch(function(error) {
					console.log(error);
				});
		},
		markSelectedEvaluator(evaluation){
			this.selectedEvaluator=evaluation;
			this.loadNotes(evaluation.id);
		},
		loadNotes(id) {
			let _vm = this;
			_vm.showLoader = true;
			this.axios
				.get("/get_evaluation_notes.php?evaluation_id="+id)
				.then(function(response) {
					_vm.showLoader = false;
					_vm.noteList = response.data.data;

				})
				.catch(function(error) {
					console.log(error);
				});
		},
		getOpenEvaluations() {
			let _vm = this;
			_vm.showLoader = true;
			this.axios
				// .get("/get_evaluations.php?eval_selection_type=Not-Flagged")
				.get("/get_evaluations.php?eval_selection_type="+_vm.selectFlaggedUnFlagged)

				.then(function(response) {
					_vm.showLoader = false;
					_vm.evaluations = response.data.data;
					_vm.tableData = response.data.data;

				})
				.catch(function(error) {
					console.log(error);
				});
		},
		filterFlaggedUnFlaged() {
			const _vm =this;
			// let id = -1;
			if (_vm.selectFlaggedUnFlagged == 'Not-Flagged') {

				_vm.submitButtonValue = 'Flagged';

			} else {

				_vm.submitButtonValue = _vm.selectFlaggedUnFlagged;

			}

			_vm.getOpenEvaluations();
			console.log(_vm.selectFlaggedUnFlagged,_vm.submitButtonValue);


		  }

	},
	mounted() {
		this.getOpenEvaluations();
	}
};
